<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 490.667 490.667" style="enable-background:new 0 0 490.667 490.667;" xml:space="preserve">
<g>
	<g>
		<path d="M479.904,74.667c0.025-2.815-1.064-5.526-3.029-7.541l-64-64c-2.006-1.981-4.722-3.076-7.541-3.04V0H138.667
			C132.776,0,128,4.776,128,10.667v181.419l-12.309,0.107c-2.814,0.04-5.497,1.19-7.467,3.2L13.739,291.2
			c-1.963,1.99-3.066,4.671-3.072,7.467V426.56c-0.003,2.869,1.151,5.618,3.2,7.627l41.771,40.917
			c1.995,1.951,4.676,3.042,7.467,3.04h0.107c2.814-0.04,5.497-1.19,7.467-3.2l8.203-8.373c8.618,5.591,18.676,8.556,28.949,8.533
			h0.565c6.729-0.075,13.382-1.429,19.605-3.989V480c0,5.891,4.776,10.667,10.667,10.667h330.667
			c5.891,0,10.667-4.776,10.667-10.667V74.667H479.904z M416,36.416L443.584,64H416V36.416z M117.995,330.667
			c-2.832-0.002-5.549,1.122-7.552,3.125l-22.645,22.645c-8.312,8.303-20.501,11.393-31.765,8.053l-6.059,20.459
			c18.767,5.575,39.08,0.42,52.917-13.429l19.52-19.52H128v94.485c-5.563,4.614-12.538,7.185-19.765,7.285
			c-8.502,0.176-16.708-3.126-22.72-9.141c-1.95-2.086-4.721-3.206-7.573-3.061c-2.814,0.04-5.497,1.19-7.467,3.2l-7.467,7.627
			L32,422.08V303.04l88.277-89.6l7.723-0.021V256c0.001,2.529,0.901,4.974,2.539,6.901l21.568,21.973
			c2,2.001,4.713,3.125,7.541,3.125L224,288v10.517c-0.064,10.526-5.194,20.377-13.781,26.464
			c-5.359,3.692-11.711,5.675-18.219,5.685H117.995z M458.667,469.333H149.333V352H192c29.414,0.041,53.292-23.77,53.333-53.184
			c0-0.05,0-0.1,0-0.149V288c-0.035-11.768-9.566-21.298-21.333-21.333h-59.947l-14.72-14.688V21.333h245.333V64
			c0,11.782,9.551,21.333,21.333,21.333h42.667V469.333z"/>
	</g>
</g>
<g>
	<g>
		<rect x="170.667" y="64" width="21.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="213.333" y="64" width="21.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="170.667" y="128" width="245.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="170.667" y="192" width="245.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="256" y="64" width="106.667" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="288" y="256" width="85.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="394.667" y="256" width="21.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="288" y="320" width="85.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="394.667" y="320" width="21.333" height="21.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="170.667" y="373.333" width="245.333" height="21.333"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
